import {
  columnOrderingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  type Row,
  type RowData,
  rowSelectionFeature,
  rowSortingFeature,
  type Table,
  tableFeatures,
} from '@tanstack/react-table';
import { createSortedRowModel } from './sorted-row-model';

/**
 * The feature set registered for every table rendered through TanStackTable.
 * v9 only bundles what is registered here — add a feature when the shared
 * wrapper starts using it, not preemptively.
 */
export const appTableFeatures = tableFeatures({
  rowSortingFeature,
  rowSelectionFeature,
  columnVisibilityFeature,
  columnOrderingFeature,
  columnSizingFeature,
  // Local, decorate-first replacement for the library's sorted row model —
  // see sorted-row-model.ts. Same ordering, one sort-key computation per row.
  sortedRowModel: createSortedRowModel(),
});

export type AppTableFeatures = typeof appTableFeatures;

/** Table instance parameterized with the app-wide feature set. */
export type AppTable<TData extends RowData> = Table<AppTableFeatures, TData>;

/** Row instance parameterized with the app-wide feature set. */
export type AppRow<TData extends RowData> = Row<AppTableFeatures, TData>;
